"use strict";
/**
 * THE CONCESSION POLICY - what management sees and decides, in one vocabulary.
 *
 * Owner, 2026-10-17: the Discount Rules page "should update with the concession flow with all sections - appointment,
 * OP - and these rules modification in all possible ways: percentage wise, amount wise, addition of new rule, inactive
 * old rule, field setup".
 *
 * The runtime has always decided a concession from `FinDiscountRule` rows: one row per (SECTION x CATEGORY), where the
 * section is the kind of line (Lab, Radiology, everything else) and the category is who it is for. The page shows
 * those rows as the grid a manager thinks in - who gets what, where - and every change is written back as rows, so the
 * counters (Cash Counter and the Appointment dialog) need no new mechanism and cannot disagree with the page.
 *
 * Pure by construction (no Prisma, no clock): the page and the server print the same words.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONCESSION_CATEGORY_NAMED_BY_EARLIER_FLOW = exports.CONCESSION_CATEGORY_NAMED_BY = exports.CONCESSION_CATEGORY_CODE = exports.CONCESSION_CATEGORY_LABEL = exports.CONCESSION_CATEGORIES = exports.CONCESSION_SECTION_CODE = exports.CONCESSION_SECTION_LABEL = exports.CONCESSION_SECTIONS = void 0;
exports.formatConcessionRate = formatConcessionRate;
/**
 * WHERE a concession is given. APPOINTMENT is the doctor's consultation booked on the Appointment screen; the other
 * three are the kinds of line on the Cash Counter. Stored in `FinDiscountRule.serviceFamily`.
 */
exports.CONCESSION_SECTIONS = ['APPOINTMENT', 'LAB', 'RADIOLOGY', 'OTHER'];
exports.CONCESSION_SECTION_LABEL = {
    APPOINTMENT: 'Appointment (consultation)',
    LAB: 'Lab',
    RADIOLOGY: 'Radiology',
    OTHER: 'Other OP services',
};
/** Short code used inside generated rule codes - `CONC-LAB-STU-001`. */
exports.CONCESSION_SECTION_CODE = {
    APPOINTMENT: 'APPT',
    LAB: 'LAB',
    RADIOLOGY: 'RAD',
    OTHER: 'OTH',
};
/** WHO a concession is for. The order is the counter's order. */
exports.CONCESSION_CATEGORIES = ['STAFF', 'DEPENDENT', 'STUDENT', 'RETIRED', 'CAMP'];
exports.CONCESSION_CATEGORY_LABEL = {
    STAFF: 'Staff',
    DEPENDENT: 'Staff dependent',
    STUDENT: 'Student',
    RETIRED: 'Retired staff',
    CAMP: 'Camp',
};
exports.CONCESSION_CATEGORY_CODE = {
    STAFF: 'STF',
    DEPENDENT: 'DEP',
    STUDENT: 'STU',
    RETIRED: 'RET',
    CAMP: 'CMP',
};
/** How the counter identifies the person - what the "field setup" of each category is today (fixed in the system). */
exports.CONCESSION_CATEGORY_NAMED_BY = {
    STAFF: 'Employee Number (name shown, then Approve)',
    DEPENDENT: "Staff member's Employee Number + relation (Spouse / Son / Daughter); the patient is the dependent",
    STUDENT: "The patient's own name, fetched from the OP number (then Approve)",
    RETIRED: "The patient's own name, fetched from the OP number (then Approve)",
    CAMP: "The camp's name, typed",
};
/**
 * THE SAME, FOR A SITE STILL RUNNING THE EARLIER CONCESSION FLOW (2026-10-12): before the hospital's concession sheet
 * (2026-10-16) the counter picked the employee from a list or typed the code, a dependent was the staff member plus a
 * relation, and Student / Retired / Camp were a typed name - no register, no confirmation step.
 */
exports.CONCESSION_CATEGORY_NAMED_BY_EARLIER_FLOW = {
    STAFF: 'Employee picked from the list, or typed by code',
    DEPENDENT: 'The staff member, then Spouse / Son / Daughter (son or daughter not above 21, from the OP record)',
    STUDENT: "The student's name, typed",
    RETIRED: "The retired person's name, typed (administrator logins only)",
    CAMP: "The camp's name, typed",
};
/** "30%" or "₹100" - how a rate reads on screen and in messages. */
function formatConcessionRate(method, value) {
    if (method === null || value === null)
        return '—';
    if (method === 'PERCENTAGE')
        return `${value}%`;
    const rupees = value / 100;
    return `₹${Number.isInteger(rupees) ? rupees.toLocaleString('en-IN') : rupees.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}
//# sourceMappingURL=concession-policy.js.map